export default __webpack_public_path__ + "static/media/left-lines.56aa2cd9.svg";